"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
var VAlert_vue_1 = __importDefault(require("../scraps/VAlert.vue"));
var VModal_vue_1 = __importDefault(require("../scraps/VModal.vue"));
var VButton_vue_1 = __importDefault(require("../scraps/VButton.vue"));
var UnitNameInput_vue_1 = __importDefault(require("../form/UnitNameInput.vue"));
var DistrictSelect_vue_1 = __importDefault(require("../form/DistrictSelect.vue"));
var errors_1 = __importDefault(require("../../config/errors"));
exports.default = vue_1.default.extend({
    name: "create-unit-modal",
    components: {
        VAlert: VAlert_vue_1.default,
        VButton: VButton_vue_1.default,
        VModal: VModal_vue_1.default,
        UnitNameInput: UnitNameInput_vue_1.default,
        DistrictSelect: DistrictSelect_vue_1.default
    },
    props: {
        show: {
            type: Boolean,
            default: false
        },
        districts: {
            type: Array,
            required: true
        }
    },
    data: function () {
        return {
            unitName: "",
            currentDistrict: {},
            invalidUnitName: false,
            invalidDistrict: false,
            errors: errors_1.default
        };
    },
    methods: {
        onKeyDown: function (keyCode) {
            if (keyCode === 13) {
                this.onUnitCreate();
            }
        },
        onDistrictChange: function (option) {
            this.currentDistrict = {
                id: option.value,
                name: option.name,
                last_modified: ""
            };
        },
        onClose: function () {
            this.invalidUnitName = false;
            this.invalidDistrict = false;
            this.unitName = "";
            this.currentDistrict = {};
            this.$emit("close");
        },
        onUnitCreate: function () {
            if (!this.$refs["unitNameInput"].isValid(true)) {
                this.$refs["unitNameInput"].appendValidationClass();
                return;
            }
            if (!this.currentDistrict.id) {
                this.invalidDistrict = true;
                return;
            }
            this.$emit("createUnit", {
                name: this.unitName,
                district_id: this.currentDistrict.id
            });
            this.currentDistrict = {};
            this.unitName = "";
        }
    }
});
